import { useState } from "react";
import axios from "axios";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Smartphone, Loader2, Check } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Walk-in prospect texts themselves the signup URL. Public POST endpoint —
 * rate-limited to 1 per phone per 10 min. Perfect for the iPad pitch where
 * the dealer is watching but wants to sign up later on their own phone.
 */
export default function TextMeLinkForm() {
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!phone.trim()) return;
    setBusy(true);
    try {
      await axios.post(`${API}/api/billing/text-me-the-link`, { phone: phone.trim() });
      setSent(true);
      toast.success("Signup link texted — check your phone");
      setTimeout(() => setSent(false), 6000);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Couldn't send the text");
    } finally { setBusy(false); }
  };

  return (
    <form
      onSubmit={submit}
      className="rounded-lg border border-dashed border-navy/30 bg-muted/30 p-3 space-y-2"
      data-testid="text-me-link-form"
    >
      <div className="flex items-center gap-2">
        <Smartphone className="w-4 h-4 text-navy" />
        <div className="font-mono-label text-navy text-[0.65rem] tracking-widest">TEXT ME THIS LINK</div>
      </div>
      <div className="flex items-center gap-2">
        <Input
          type="tel"
          inputMode="tel"
          placeholder="+1 555 111 0100"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          disabled={busy || sent}
          className="flex-1"
          data-testid="text-me-link-phone"
        />
        <Button
          type="submit"
          size="sm"
          disabled={busy || sent || !phone.trim()}
          className="bg-navy hover:bg-navy/85"
          data-testid="text-me-link-submit"
        >
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : sent ? <><Check className="w-3.5 h-3.5 mr-1" /> Sent</> : "Send"}
        </Button>
      </div>
      <div className="text-[0.7rem] text-muted-foreground">
        We'll text you a link back to this signup page so you can finish it on your own phone. Reply STOP to opt out.
      </div>
    </form>
  );
}
